import { getLocale } from "@travily/i18n";
import { getDisplayNames } from "./display-names";

const ISO_REGION_FORMAT = /^([A-Za-z]{2,3}|\d{3})$/;

export function localizedCountryName(code: string, locale: string = getLocale()): string {
  if (!ISO_REGION_FORMAT.test(code)) return code;
  return getDisplayNames("region", locale).of(code) ?? code;
}
